import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import usePageMeta from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "Pagina niet gevonden, LevelLeven",
    description: "De pagina die je zoekt bestaat niet meer.",
  });

  return (
    <section className="min-h-[70vh] flex items-center">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 py-24 w-full">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.3em] text-[#E06B3F] mb-8">
            404, Verkeerde afslag
          </p>
          <h1 className="font-heading text-6xl sm:text-7xl leading-[1.05] tracking-tight text-[#1D2A22] font-light">
            Deze pagina{" "}
            <span className="italic text-[#E06B3F]">staat even stil</span>.
          </h1>
          <p className="mt-8 text-lg text-[#4A5D4E] font-light leading-relaxed">
            Geen zorgen, laten we je weer in beweging brengen.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link
              to="/"
              className="group inline-flex items-center gap-3 bg-[#1D2A22] hover:bg-[#E06B3F] text-[#FAF7F1] rounded-full pl-7 pr-2 py-2 transition-colors duration-300"
            >
              <span className="text-base font-medium">Terug naar home</span>
              <span className="bg-[#E06B3F] group-hover:bg-[#FAF7F1] group-hover:text-[#1D2A22] text-white w-10 h-10 rounded-full flex items-center justify-center transition-colors">
                <ArrowUpRight size={16} />
              </span>
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 border border-[#1D2A22] text-[#1D2A22] hover:bg-[#1D2A22] hover:text-white rounded-full px-6 py-3 transition-colors"
            >
              Neem contact op
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
